module.exports = __webpack_public_path__ + "static/media/we.109855eb.jpg";